// extracted by mini-css-extract-plugin
export default {"section":"Concept_section__Npq9+","container":"Concept_container__WuPtO","symbol":"Concept_symbol__-U3E-","slogan":"Concept_slogan__pzZS7","title":"Concept_title__W+xDm"};